
export { default } from './drag-handle';


//////////////////
// WEBPACK FOOTER
// ../~/react-beautiful-dnd/esm/view/drag-handle/index.js
// module id = 1887
// module chunks = 1